import React, { useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import { useForm, FieldErrors } from "react-hook-form";
import CommonForm, { FormFieldConfig } from "Components/Common/CommonForm";
import { CHECKLIST_CATEGORY_OPTIONS, Checklist_Type_OPTIONS } from "api/modules/common.option";

interface AssignCategoryModalProps {
  isOpen: boolean;
  toggle: () => void;
  selectedType: any | null;
  existingCategory?: any;
  onSave: (payload: any) => void;
  isLoading: boolean;
}

interface FormValues {
  checklisttype: string | number;
  checklistcategory: string | number;
}

const AssignCategoryModal: React.FC<AssignCategoryModalProps> = ({
  isOpen,
  toggle,
  selectedType,
  existingCategory,
  onSave,
  isLoading,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>({
    defaultValues: {
      checklisttype: "",
      checklistcategory: "",
    },
    mode: "onChange",
  });

  useEffect(() => {
    if (selectedType) {
      reset({
        checklisttype: selectedType.value ?? selectedType.label ?? "",
        checklistcategory: existingCategory ? Number(existingCategory) || existingCategory : "",
      });
    } else {
      reset({
        checklisttype: "",
        checklistcategory: "",
      });
    }
  }, [selectedType, existingCategory, isOpen, reset]);

  const onSubmit = (values: FormValues) => {
    const payload = {
      checklisttype: typeof values.checklisttype === "object" ? (values.checklisttype as any).value : values.checklisttype,
      checklistcategory: typeof values.checklistcategory === "object" ? (values.checklistcategory as any).value : values.checklistcategory,
    };
    onSave(payload);
  };

  const fields: FormFieldConfig[] = useMemo(
    () => [
      {
        name: "checklisttype",
        label: "Checklist Type",
        placeholder: "Select Checklist Type",
        type: "select",
        options: Checklist_Type_OPTIONS.length > 0 ? Checklist_Type_OPTIONS : (selectedType ? [selectedType] : []),
        disabled: true,
        required: true,
      },
      {
        name: "checklistcategory",
        label: "Category",
        placeholder: "Select Category",
        type: "select",
        options: CHECKLIST_CATEGORY_OPTIONS,
        required: true,
      },
    ],
    [selectedType]
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      backdrop="static"
      className="common_modal"
    >
      <ModalHeader toggle={toggle} className="p-3">
        {existingCategory ? "Update Category" : "Assign Category"}
      </ModalHeader>

      <ModalBody>
        <form id="assignCategoryForm" onSubmit={handleSubmit(onSubmit)}>
          <CommonForm
            fields={fields}
            control={control}
            errors={errors as FieldErrors}
            columns={1}
          />
        </form>
      </ModalBody>

      <ModalFooter>
        <Button outline color="dark" size="sm" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color="primary"
          size="sm"
          type="submit"
          form="assignCategoryForm"
          disabled={isSubmitting || isLoading}
          outline
        >
          {isLoading && <Spinner size="sm" className="me-2" />}
          {existingCategory ? "Update" : "Save"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AssignCategoryModal;
